<template>
    <multi-select-input
        :items="orderedTeams"
        value-key-name="id"
        label-key-name="name"
        v-bind="$attrs"
    />
</template>

<script lang="ts" setup>
    import { MultiSelectInput } from '@keyvue/one-ui';
    import type { Team } from '@keyvue/one-api-client';
    import { computed } from 'vue';

    export interface Props {
        teams: Team[]
    }

    const props = defineProps<Props>();

    const orderedTeams = computed(() => (
        [...props.teams].sort((a, b) => a.name.localeCompare(b.name))
    ));
</script>
